const labelMenu = {
  dashboard: 'Dashboard',
  campaigns: 'Campanhas',
  inventory: 'Inventário',
  advertisers: 'Anunciantes',
  reports: 'Relatórios',
  users: 'Usuários',
  monitoring: 'Monitoramento',
  keywordPerformance: 'Desempenho',
};

const submenu = {
  banners: 'Banners',
  campaigns: 'Campanhas',
  sponsored: 'Patrocinados',
  dashboard: 'Dashboard',
  actives: 'Ativos',
  reports: 'Relatórios',
  advertisers: 'Anunciantes',
  creation: 'Criação',
  performance: 'Desempenho',
};

export { labelMenu, submenu };
